import { useEffect, useId, useState } from "react";

import FA_LANG from "@/assets/locale/fa";
import { QuizProps } from "./Test";
import ResponseInput from "./inputs/ResponseInput";
import SwitchButton from "@/app/components/ui/SwitchButton";
import icons from "@/assets/icons";
import { detectQuestionDirection } from "../questionSettings/QuestionSettings";

export default function FillInTheBlank({
  selectedQuiz,
  updateQuizDetail,
  updateQuestion,
  addNewChoice,
  removeChoice,
}: QuizProps) {
  const [selectedWord, setSelectedWord] = useState<string>("    ");
  const [responseTypeByChar, setResponseTypeByChar] = useState<boolean>(
    selectedQuiz?.quiz_detail_json?.[0]?.letterWise
  );
  const [sentence, setSentence] = useState<string>(selectedQuiz.question);

  useEffect(() => {
    if (
      selectedQuiz.quiz_detail_json?.length === 1 &&
      selectedQuiz.quiz_detail_json?.[0]?.choice?.text &&
      selectedQuiz.quiz_detail_json[0].letterWise
    ) {
      setSelectedWord(
        selectedQuiz.quiz_detail_json?.[0]?.choice?.text === ""
          ? "    "
          : selectedQuiz.quiz_detail_json?.[0]?.choice?.text
      );
    }
  }, [selectedQuiz.quiz_detail_json[0].isChoice]);

  useEffect(() => {
    setSentence(selectedQuiz.question);
    setResponseTypeByChar(selectedQuiz?.quiz_detail_json?.[0]?.letterWise);
    if (
      selectedQuiz.quiz_detail_json?.length === 1 &&
      selectedQuiz.quiz_detail_json[0].letterWise
    ) {
      setSelectedWord(
        selectedQuiz.quiz_detail_json?.[0]?.choice?.text === ""
          ? "    "
          : selectedQuiz.quiz_detail_json?.[0]?.choice?.text
      );
    }
  }, [selectedQuiz.id]);

  const handleQuestionChange = (value: string, i: number) => {
    setSelectedWord("    ");
    setResponseTypeByChar(true);
    let resetQuiz: Quiz = {
      ...selectedQuiz,
      quiz_detail_json: [
        {
          id: "choice1",
          choice: {
            fileId: "",
            text: "",
            url: "",
          },
          letterWise: true,
          ordering: 1,
          isCorrect: false,
          correctOrder: 0, //order of word in the sentence
          isChoice: false, //is there any choices?
          answers: [
            {
              id: "answer1",
              answer: {
                fileId: "",
                text: "",
                url: "",
              },
            },
          ],
        },
      ],
      question: value.trim(),
    };
    setSentence(value.trim());
    if (updateQuestion) updateQuestion(resetQuiz);
  };

  function splitSentence(string: string): string[] {
    const words: string[] = string?.split(/(?<!\u00A0) /);
    return words;
  }

  function splitWord(selectedWord: string): string[] {
    const words: string[] = (
      selectedQuiz.quiz_detail_json[0].choice.text === ""
        ? selectedWord.replace(/[\u200B-\u200D\uFEFF]/g, "")
        : selectedQuiz.quiz_detail_json[0].choice.text.replace(
            /[\u200B-\u200D\uFEFF]/g,
            ""
          )
    ).split("");
    return words;
  }
  const handleSelectedWordChange = (word: string, index: number) => {
    const newDetails: QuizDetail[] = [...selectedQuiz.quiz_detail_json];
    const isWordAlreadyAdded = newDetails.some(
      (detail) => detail.choice.text === word
    );

    if (isWordAlreadyAdded) {
      return newDetails;
    }

    if (responseTypeByChar) {
      if (!newDetails[0].isChoice) {
        newDetails[0] = {
          ...newDetails[0],
          choice: { ...newDetails[0].choice, text: word },
          correctOrder: index,
        };
        setSelectedWord(word);
        updateQuizDetail(newDetails[0]);
      }
    } else {
      const firstAvailableChoiceIndex = newDetails.findIndex(
        (detail) => detail.choice.text === ""
      );

      if (firstAvailableChoiceIndex !== -1) {
        newDetails[firstAvailableChoiceIndex] = {
          ...newDetails[firstAvailableChoiceIndex],
          choice: {
            ...newDetails[firstAvailableChoiceIndex].choice,
            text: word,
          },
          correctOrder: index,
          isChoice: true,
        };
        updateQuizDetail(newDetails[firstAvailableChoiceIndex]);
      } else {
        // while (newDetails.length < 2)
        addNewChoice!(
          {
            id: "choice" + (newDetails.length + 1),
            choice: {
              fileId: "",
              text: word,
              url: "",
            },
            letterWise: false,
            correctOrder: index,
            isChoice: true,
            ordering: newDetails.length + 1,
            isCorrect: false,
            answers: [
              {
                id: "answer" + (newDetails.length + 1),
                answer: {
                  fileId: "",
                  text: "",
                  url: "",
                },
              },
            ],
          },
          newDetails.length
        );
      }
    }
    // for (let index = 0; index < newDetails.length; index++) {
    //   const element = newDetails[index];
    //   updateQuizDetail(element);
    // }
  };

  const removeQuizDetails = (i: string) => {
    if (selectedQuiz?.quiz_detail_json?.length > 1) {
      removeChoice!(i);
    }
  };

  const handleDeleteInputs = (i: string) => {
    if (selectedQuiz.quiz_detail_json.length > 1) {
      removeQuizDetails(i);
    }
  };

  const handleLetterWiseChange = () => {
    const isLetterWise = !responseTypeByChar;
    setResponseTypeByChar(isLetterWise);

    if (isLetterWise) {
      const firstChoiceText =
        selectedQuiz.quiz_detail_json?.length > 0 &&
        selectedQuiz.quiz_detail_json[0].choice.text !== ""
          ? selectedQuiz.quiz_detail_json[0].choice.text
          : "    ";

      let firstChoice: QuizDetail[] = [
        {
          ...selectedQuiz.quiz_detail_json[0],
          letterWise: isLetterWise,
          isChoice: false,
          isCorrect: false,
          ordering: 1,
        },
      ];

      let updatedQuiz: Quiz = {
        ...selectedQuiz,
        quiz_detail_json: firstChoice,
      };
      updateQuestion(updatedQuiz);
      setSelectedWord(firstChoiceText);
    } else {
      if (selectedQuiz.quiz_detail_json.length < 1) {
        addNewChoice!(
          {
            id: "choice2",
            choice: {
              fileId: "",
              text: "",
              url: "",
            },
            letterWise: false,
            correctOrder: 1,
            isChoice: true,
            ordering: 2,
            isCorrect: false,
            answers: [
              {
                id: "answer" + (selectedQuiz.quiz_detail_json.length + 1),
                answer: {
                  fileId: "",
                  text: "",
                  url: "",
                },
              },
            ],
          },
          2
        );
      }
      var updated_1: QuizDetail[] = selectedQuiz.quiz_detail_json?.map(
        (choice) => ({
          ...choice,
          letterWise: isLetterWise,
          isChoice: true,
        })
      );
      for (let index = 0; index < updated_1.length; index++) {
        const element = updated_1[index];
        updateQuizDetail(element);
      }
    }
  };
  const image_id = useId();

  const renderInputs = () => {
    return selectedQuiz.quiz_detail_json.map((_, i) => (
      <div className="flex w-full items-start flex-grow" key={i}>
        <div className="flex p-[6px] flex-col justify-end items-end flex-grow self-stretch rounded-xl bg-purple-10">
          <div className="flex flex-col justify-center items-end gap-[6px] flex-grow self-stretch">
            <div className="flex justify-between items-center self-stretch">
              <div className="flex justify-start items-center gap-1">
                <div className="flex p-1 flex-col items-center gap-[10px] rounded-[100px] bg-bg-white">
                  <div className="flex justify-start items-center gap-1">
                    <div className="text-sm text-nowrap">
                      {FA_LANG.CHOICE}
                      {i + 1}
                    </div>
                  </div>
                </div>
              </div>
              {selectedQuiz.quiz_detail_json.length > 1 && (
                <button
                  className="flex justify-center items-center w-6 h-6"
                  onClick={() =>
                    handleDeleteInputs(selectedQuiz?.quiz_detail_json?.[i]?.id)
                  }
                >
                  {icons.closeSquare}
                </button>
              )}
            </div>
            <ResponseInput
              placeHolder={FA_LANG.BLANK}
              styleClass="md:h-[114px] w-[90px] md:min-w-[157px] min-w-[127px]"
              inputValue={selectedQuiz?.quiz_detail_json[i]?.choice?.text}
              index={i}
              hasFile={false}
              id={`file-input-fill-in-the-blank-choice-${image_id + i}`}
              tabIndex={0}
            />
          </div>
        </div>
      </div>
    ));
  };
  function handleQuestionAudioChange(audio: any): void {
    const updatedSelectedQuiz: Quiz = {
      ...selectedQuiz,
      question_voice: audio,
      question_voice_link: undefined,
    };
    if (updateQuestion) updateQuestion(updatedSelectedQuiz);
  }
  return (
    <div className="flex flex-col gap-8 items-start w-full">
      <ResponseInput
        inputValue={sentence}
        valueUpdated={handleQuestionChange}
        placeHolder={FA_LANG.FILL_IN_THE_BLANK_QUESTION_PLACEHOLDER}
        id={`file-input-question-matching-${image_id}`}
        styleClass={"h-[150px] w-full"}
        index={0}
        tabIndex={0}
        handleVoiceChange={handleQuestionAudioChange}
        hasAudio={true}
        inputVoice={selectedQuiz.question_voice_link}
        // setSentence={setSentence}
        // hasFile={true}
      />
      <div className="flex flex-col w-full justify-start items-start rounded-xl ">
        <div className="flex flex-col justify-center items-start gap-6 self-stretch">
          <div className="flex flex-col justify-center items-start self-stretch rounded-xl gap-[6px]">
            <div className="text-right text-[10px] font-medium leading-none">
              {FA_LANG.BLANK_SELECT_WORD}
            </div>
            <div
              className={`flex ${
                detectQuestionDirection(sentence) === "ltr"
                  ? " flex-row-reverse "
                  : " "
              } p-3 justify-between items-center self-stretch rounded-xl bg-bg`}
            >
              <div
                className={`flex ${
                  detectQuestionDirection(sentence) === "ltr"
                    ? " flex-row-reverse "
                    : " "
                } justify-start items-center content-center gap-3 overflow-auto`}
              >
                {splitSentence(sentence)?.map((word, index) => {
                  return (
                    <div
                      className="flex flex-col items-start gap-[10px]"
                      key={"splited" + index}
                    >
                      <button
                        className={`flex p-3 justify-center items-center gap-[10px] rounded-[6px] transition-colors duration-300  ${
                          selectedQuiz.quiz_detail_json.some(
                            (details) =>
                              details.correctOrder === index &&
                              details.choice.text !== ""
                          )
                            ? " border border-purple-20 opacity-60 bg-purple-20"
                            : " focus:border focus:border-purple-20 focus:opacity-60 "
                        }  hover:bg-purple-20 `}
                        onClick={() => handleSelectedWordChange(word, index)}
                      >
                        <div className="flex justify-center items-center gap-[10px] ">
                          <div className="text-right text-xs font-medium leading-tight h-3">
                            {word}
                          </div>
                        </div>
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="flex w-full flex-col items-start gap-2">
            <div className="text-right text-[10px] font-medium leading-none">
              {FA_LANG.CHOICE_TITLE}
            </div>
            <div className="flex flex-col items-end gap-4 flex-grow self-stretch w-auto">
              {!selectedQuiz?.quiz_detail_json?.[0]?.isChoice ||
              responseTypeByChar ? (
                <div className="flex flex-col justify-end items-end flex-grow rounded-xl w-full md:h-[166px] h-[100px]">
                  <div
                    className={`flex p-3 ${
                      detectQuestionDirection(selectedWord) === "ltr"
                        ? " flex-row-reverse "
                        : " "
                    } justify-end items-center gap-3 flex-grow self-stretch rounded-xl bg-purple-10 w-full`}
                  >
                    {selectedWord &&
                      splitWord(
                        selectedWord.replace(/[\u200B-\u200D\uFEFF]/g, "")
                      ).map((char, index) => {
                        return (
                          <div
                            className="flex flex-col justify-end items-start flex-grow self-stretch rounded-xl"
                            key={"split-word" + index}
                          >
                            <div className="flex flex-col justify-center items-start gap-[6px] flex-grow self-stretch">
                              <div className="flex flex-col justify-center items-start flex-grow self-stretch rounded-xl">
                                <div
                                  className={`flex p-3 ${
                                    detectQuestionDirection(selectedWord) ===
                                    "rtl"
                                      ? " justify-between "
                                      : " justify-end "
                                  }  items-center flex-grow self-stretch rounded-xl bg-bg-white`}
                                >
                                  {char}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              ) : (
                <div className="flex w-full gap-3 overflow-auto">
                  {renderInputs()}
                </div>
              )}
              <SwitchButton
                rightButtonTitle={FA_LANG.LETTER_WISE}
                leftButtonTitle={FA_LANG.MULTIPLE_ANSWER}
                width="w-[328px]"
                isRightButtonSelected={
                  selectedQuiz?.quiz_detail_json?.[0]?.isChoice === undefined
                    ? true
                    : !selectedQuiz?.quiz_detail_json?.[0]?.isChoice
                }
                handleChange={handleLetterWiseChange}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
